import {sessionStorageClient} from 'client/common/utils/storage';

import {CreativesBoxType} from 'client/creatives/types';

const IS_ONBOARDING_SHOWED_KEY = 'isOnboardingShowed';

export function getIsOnboardingShowed(boxType: CreativesBoxType) {
    return sessionStorageClient.getDataFromStorage(`${IS_ONBOARDING_SHOWED_KEY}_${boxType}`);
}

export function setIsOboardingShowed(boxType: CreativesBoxType) {
    return sessionStorageClient.saveDataToStorage(`${IS_ONBOARDING_SHOWED_KEY}_${boxType}`, true);
}
